import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  OnInit,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import videojs from 'video.js';
@Component({
  selector: 'app-app-video-player',
  templateUrl: './app-video-player.component.html',
  styleUrl: './app-video-player.component.scss',
})
export class AppVideoPlayerComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() videoUrl!: string;
  @Input() posterUrl!: string;
  @ViewChild('videoPlayer') videoElement: ElementRef;
  player = null;

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.initPlayer();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['videoUrl'] && this.videoUrl) {
      if (this.player) {
        this.player.src({ src: this.videoUrl, type: 'video/mp4' });
        if (this.posterUrl) {
          this.player.poster(this.posterUrl);
        }
      }
    }
  }

  initPlayer() {
    this.player = videojs(this.videoElement.nativeElement, {
      controls: true,
      autoplay: false,
      poster: this.posterUrl,
      preload: 'auto'
    }, () => {
      // Only set sources AFTER player is ready
      this.player.src({
        src: this.videoUrl,
        type: 'video/mp4'
      });
    });
  }

  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
